module.exports = __webpack_public_path__ + "static/hamilton-writing-70680587bae6567c3511b22a1d82c86a.gif";